<template>
  <div class="readNextContainer bg-light w-100">
    <h3 class="text-center">What to read next</h3>
    <div class="readNextList mx-auto">
      <PostGridItem
        v-for="post in posts.slice(0, 3)"
        :key="post.id"
        :post="post"
      />
    </div>
  </div>
</template>

<script>
import PostGridItem from './PostGridItem.vue';

export default {
  name: 'ReadNext',
  components: {
    PostGridItem
  },
  props: {
    posts: {
      type: Array,
      required: true,
    }
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';
.readNextContainer {
  padding: 100px 15px 90px;

  h3 {
    margin-bottom: 50px;
  }

  .readNextList {
    max-width: 984px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 40px;
    row-gap: 15px;
    @include media-breakpoint-down(sm) {
      column-gap: 15px;
    }
    @include media-breakpoint-down(xs) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    >* {
      max-width: 400px;
      margin: 0 auto;
    }
  }
}
</style>